module.exports = __webpack_public_path__ + "dfcaebf7d29e46a56f5d73e083b036b6.pdf";